import { WSInputText } from "@wingspanhq/fe-component-library";
import React from "react";
import { IDynamicFieldProps } from "../../types";
import { formatReadOnlyValue } from "../../utils/formatReadOnlyValue";
import { isSensitiveField } from "../../utils/isSharedPiiField";

type Props = IDynamicFieldProps & {
  value?: unknown;
};

export const DynamicFieldReadOnly: React.FC<Props> = ({ field, value }) => {
  const resolved = value ?? field.prefill?.value;
  // A read-only field with nothing to read renders nothing: server-stamped
  // fields (e.g. the certification's dateSigned, recorded at submit) would
  // otherwise show an empty disabled input with an explanatory hint — noise
  // the design review asked to drop. The value appears on the review screen
  // once it exists.
  if (resolved == null || resolved === "") return null;
  return (
    <WSInputText
      label={field.label}
      helperText={field.description ?? field.ui?.helpText}
      value={formatReadOnlyValue(resolved)}
      onChange={() => undefined}
      disabled
      fsExclude={isSensitiveField(field)}
    />
  );
};
